import { DatePipe } from "@angular/common";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Component, OnInit } from "@angular/core";
import {
    FormBuilder,
    FormControl,
    FormGroup,
    Validators,
} from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { LocalStorageService, SessionStorageService } from "ngx-webstorage";
import "rxjs/Rx";
import { environment } from "src/environments/environment";
import { MyserviceService } from "../myservice.service";

@Component({
    selector: "app-scheduler",
    templateUrl: "./scheduler.component.html",
    styleUrls: ["./scheduler.component.css"],
})
export class SchedulerComponent implements OnInit {
    loader:boolean;
    noRecords: boolean = false;
    statusArray = [];
    activeUsersArray = [];
    display: boolean;
    searchData: any = [];
    detailInfoData: any;
    updateSchedulerResponse: any = [];
    addStatus: any = [];
    tableHeaders: { field: string; header: string }[];
    editResponse: any = [];
    responseData: any = [];
    activeUsers: any = [];
    schedulerTimeList: any = [];
    document: any = {};
    dtOptions: DataTables.Settings = {};
    schedulerArray = [];
    selectedUsers = [];
    emailList = [];
    schedulerForm: FormGroup;
    schedulerDetailInfoForm: FormGroup;
    responseMsg: boolean = false;
    userRole: string;
    constructor(
        private myservice: MyserviceService,
        private router: Router,
        private route: ActivatedRoute,
        public localstorage: LocalStorageService,
        private http: HttpClient,
        private fb: FormBuilder,
        public datepipe: DatePipe,
        public session: SessionStorageService
    ) {}

    ngOnInit() {
        this.userRole = this.session.retrieve("userRole");
        this.schedulerForm = this.fb.group({
            status: new FormControl("", Validators.required),
        });
        this.schedulerDetailInfoForm = this.fb.group({
            title: new FormControl("", Validators.required),
            type: new FormControl("", Validators.required),
            receiverIds: new FormControl("", Validators.required),
            emailList: new FormControl("", Validators.required),
            status: new FormControl("", Validators.required),
        });

        this.statusArray.push({ label: "Select", value: "-1" });
        this.statusArray.push({ label: "Active", value: "Active" });
        this.statusArray.push({ label: "InActive", value: "InActive" });

        this.schedulerArray.push({ label: "Select", value: "-1" });
        this.schedulerArray.push({ label: "Daily", value: "Daily" });
        this.schedulerArray.push({ label: "Weekly", value: "Weekly" });
        this.schedulerArray.push({ label: "Monthly", value: "Monthly" });

        this.tableHeaders = [
            { field: "title", header: "Title" },
            { field: "type", header: "Type" },
            { field: "status", header: "Status" },
            { field: "delete", header: "Delete" },
        ];

        this.myservice
            .activeUsers(this.localstorage.retrieve("token"))
            .subscribe((data) => {
                this.activeUsers = data;
                let keys = Object.keys(data);
                for (var i = 0; i < keys.length; i++) {
                    this.activeUsersArray.push({
                        label: keys[i],
                        value: data[keys[i]],
                    });
                }
            });

        let flag = this.route.snapshot.paramMap.get("flag");
        if (flag && flag === "back") {
            this.search(document);
        } else {
            this.document.status = "-1";
        }
        this.dtOptions = {
            order: [[0, "desc"]],
        };
        if (!this.document.status) {
            this.document.status = "-1";
        }
    }

    search(document) {
        this.loader=true;
        this.document = document;
        this.document.createdBy = this.session.retrieve("UserDetails").loginId;
        this.searchData = [];
        let headers = new HttpHeaders();
        headers = headers.append(
            "Authorization",
            this.localstorage.retrieve("token")
        );
        this.http
            .post(environment.apiUrl + "/scheduler/search", this.document, {
                headers: headers,
            })
            .subscribe((data) => {
                this.searchData = data;
                if (this.searchData.length == 0) {
                    this.noRecords = true;
                }
                this.loader=false;
            });
    }

    add() {
        this.router.navigate(["/mscvp/add-scheduler"]);
    }

    close() {
        this.display = false;
    }

    edit(id) {
        this.display = true;
        let headers = new HttpHeaders();
        headers = headers.append(
            "authorization",
            this.localstorage.retrieve("token")
        );
        this.http
            .get(environment.apiUrl + "/scheduler/" + id, { headers: headers })
            .subscribe((data) => {
                this.detailInfoData = data;

                this.emailList = [];
                this.selectedUsers = [];
                this.schedulerDetailInfoForm.controls.title.setValue(
                    this.detailInfoData.title
                );
                this.schedulerDetailInfoForm.controls.type.setValue(
                    this.detailInfoData.type
                );
                this.schedulerDetailInfoForm.controls.receiverIds.setValue(
                    this.detailInfoData.receiverIds
                );
                this.schedulerDetailInfoForm.controls.emailList.setValue(
                    this.detailInfoData.externalEmails.split(",")
                );
                this.schedulerDetailInfoForm.controls.status.setValue(
                    this.detailInfoData.status
                );
            });
    }

    update(schedulerDetailInfoForm, document) {
        let requestpayload = {};
        requestpayload["externalEmails"] =
            schedulerDetailInfoForm.emailList.toString();
        requestpayload["format"] = document.format;
        requestpayload["hours"] = document.hours;
        requestpayload["reportsType"] = document.reportsType;
        requestpayload["title"] = schedulerDetailInfoForm.title;
        requestpayload["type"] = schedulerDetailInfoForm.type;
        requestpayload["id"] = document.id;
        requestpayload["receiverEmails"] =
            schedulerDetailInfoForm.receiverIds.toString();
        requestpayload["status"] = schedulerDetailInfoForm.status;
        let headers = new HttpHeaders();
        headers = headers.append(
            "Authorization",
            this.localstorage.retrieve("token")
        );
        headers = headers.append("Access-Control-Allow-Origin", "*");
        headers = headers.append("Content-Type", "application/json");

        this.http
            .post(environment.apiUrl + "/scheduler/update", requestpayload, {
                responseType: "text",
                headers: headers,
            })
            .subscribe((data) => {
                this.updateSchedulerResponse = data;

                this.responseMsg = true;
                setTimeout(
                    function () {
                        this.responseMsg = false;
                    }.bind(this),
                    2000
                );
                this.search(this.document);
            });
    }

    delete(id) {
        // alert(id);
        let headers = new HttpHeaders();
        headers = headers.append(
            "authorization",
            this.localstorage.retrieve("token")
        );

        this.http
            .delete(environment.apiUrl + "/scheduler/" + id, {
                headers: headers,
                responseType: "text",
            })
            .subscribe((data) => {
                this.responseData = data;
                //alert(this.responseData);
            });
        this.search(this.document);
    }
}
